import { UserCountModel } from '../../models';
import { handleGeneralError } from '../errors';
import { resolver } from '../util';

const userCounts = resolver.authenticatedResolver.createResolver(
  async (root, { domain = '' }) => {
    const UserCount = UserCountModel();
    try {
      const counts = await UserCount.findUserCount(domain);
      return counts;
    } catch (error) {
      return handleGeneralError(error.message);
    }
  },
);

export default {
  Query: {
    userCounts,
  },
};
